import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';

import { UnitType } from '~/src/types/Misc';
import ButtonComponent from '../../../../../../components/common/forms/Button/ButtonComponent';
import TextInputComponent from '../../../../../../components/common/forms/TextInput/TextInputComponent';

const amountSchema = (max: number): yup.AnyObjectSchema => {
  return yup.object().shape({
    amount: yup
      .number()
      .typeError('Must be a number')
      .test('Is positive?', 'Must be >= 0', (value) => value >= 0)
      // .max(max, `Must be smaller than ${max}`)
      .integer('Must be an integer')
      .required('Is required'),
  });
};
interface Props {
  tempId: string;
  maxNumber: number;
  unitType: UnitType;
  reserve: (quantityId: string, type: UnitType, amount: number) => void;
  clear: (tempId: string, type: UnitType) => void;
}
export default function ButtonQuantities({ tempId, maxNumber, unitType, reserve, clear }: Props): JSX.Element {
  const formik = useFormik({
    initialValues: {
      amount: '',
    },
    validationSchema: amountSchema(maxNumber),
    onSubmit: async () => {},
  });

  return (
    <div style={{ height: '100%', width: 400 }}>
      <form className="form-inline" style={{ height: '100%' }}>
        <TextInputComponent
          name="amount"
          value={formik.values.amount}
          touched={formik.touched}
          errors={formik.errors}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          label={null}
          inline
          // disabled={maxNumber === 0}
        />

        <ButtonComponent
          title="Get"
          onClick={(): void => {
            formik.validateForm();
            if (formik.isValid) {
              const number = parseInt(formik.values.amount, 10);
              if (!isNaN(number)) {
                reserve(tempId, unitType, number);
              }
            }
          }}
          inline
        />
        <ButtonComponent
          title="Max"
          onClick={(): void => {
            reserve(tempId, unitType, maxNumber);
          }}
          inline
        />
        <ButtonComponent
          title="X"
          variant="danger"
          onClick={(): void => {
            clear(tempId, unitType);
          }}
          inline
        />
      </form>
    </div>
  );
}
